module.exports = __webpack_public_path__ + "static/media/MHRP29N0029.4974fe12.svg";